import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
 
export default function PageSettings (){
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        initTreeView()
    }, []);


    return (
        <>
        <Layout page_title="Settings" menu="settings" breadcrumbs={true}>
            <div className="container" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row d-flex">
                    <div className="col-md-6 col-lg-4 d-flex">
                        <div className="card card-maroons card-outlines w-100">
                            <div className="card-header">
                                <strong>Inventory</strong>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <Link to="categories" className="list-group-item list-group-item-action">Category</Link>
                                    <Link to="variant-types" className="list-group-item list-group-item-action">Variant Types</Link>
                                    <Link to="brands" className="list-group-item list-group-item-action">Brands</Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-flex">
                        <div className="card card-successs card-outlines w-100">
                            <div className="card-header">
                                <strong>Transaction</strong>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <Link to="tax-rates" className="list-group-item list-group-item-action">Tax Rates</Link>
                                    <Link to="discount-rates" className="list-group-item list-group-item-action">Discount Rates</Link>
                                    <Link to="couriers" className="list-group-item list-group-item-action">Couriers</Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}